import { OpaSubscription } from '@models/Opa';
import { ProductType } from '@pages/product-analyzer/Product';

export const getSubscriptionWithProductType = (
  subscriptions: OpaSubscription,
  productType: ProductType,
): OpaSubscription => {
  const { result = { access: '', restrictions: [] } }: OpaSubscription = subscriptions || {};
  const { access, restrictions = [] } = result;

  return {
    ...subscriptions, // Keep original properties
    result: {
      access, // Preserve `access`
      restrictions: restrictions.filter((subscription) => subscription.productType === productType),
    },
  };
};
